import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCursor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_2259_9338)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M18.721 7.99009L12.3316 4.43074C12.1264 4.31642 11.8733 4.31642 11.6681 4.43074L5.27896 7.99009C5.10649 8.08618 5 8.26388 5 8.45635V15.6338C5 15.8263 5.10649 16.004 5.27896 16.1001L11.6684 19.6594C11.8736 19.7737 12.1267 19.7737 12.3319 19.6594L18.7213 16.1001C18.8938 16.004 19.0003 15.8263 19.0003 15.6338V8.45635C19.0003 8.26388 18.8938 8.08618 18.7213 7.99009H18.721ZM18.3197 8.74404L12.1516 19.0522C12.1099 19.1217 11.9999 19.0933 11.9999 19.0128V12.2632C11.9999 12.1283 11.9252 12.0035 11.804 11.9358L5.746 8.56112C5.67401 8.52089 5.7034 8.41467 5.78679 8.41467H18.1229C18.2981 8.41467 18.4076 8.59788 18.32 8.74433H18.3197V8.74404Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2259_9338",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 15.4,
			fill: "white",
			transform: "translate(5 4.345)"
		})
	}) })]
});
export default SvgCursor;
